var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('project-info-panel',{attrs:{"project-code":_vm.projectCode,"card-bordered":false}}),_c('utilization-info-panel',{attrs:{"id":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }